// Location-grouping logic for the Charity Care ops dashboard's cohort retention
// view, shared by the Stimulus controller and its unit tests.
//
// A saved cohort stores location *names*, which is what the retention query
// filters on. Those names can drift from the dashboard's current location
// labels (a location gets renamed, or simply stops appearing in the window),
// so the helpers here compare set membership rather than counts.

// True when `names` is exactly the set of currently available locations, i.e.
// the grouping is equivalent to "all locations" and needs no server-side
// filter. A grouping that also carries stale names is *not* treated as "all":
// those names stay in the query so the filter reflects what was saved, which
// includes the case where the dashboard currently lists no locations at all.
export function coversAllLocations(names, allLabels) {
  if (allLabels.length === 0) return names.length === 0

  const available = new Set(allLabels)
  if (names.some(name => !available.has(name))) return false

  const selected = new Set(names)
  return allLabels.every(label => selected.has(label))
}

// The location names to filter the retention query by, or null for "all
// locations" (no filter). An empty grouping and one covering every location
// both mean "all".
export function activeLocationNames(names, allLabels) {
  if (names.length === 0) return null
  if (coversAllLocations(names, allLabels)) return null
  return names
}

// Saved names that no longer match any current location label. They still
// filter the query (matching nothing), so the builder surfaces them to be
// unchecked rather than hiding them.
export function staleLocationNames(names, allLabels) {
  const available = new Set(allLabels)
  return names.filter(name => !available.has(name))
}
